(function () {
  function patchProductForm() {
    var form = document.getElementById("product-form");
    if (!form) return;
    form.setAttribute("action", "#");
    var addBtn = document.getElementById("add-to-cart-btn");
    if (addBtn && addBtn.type === "submit") {
      addBtn.type = "button";
      addBtn.setAttribute("data-add-to-cart", "true");
    }
  }

  patchProductForm();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", patchProductForm);
  }

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function cartPageUrl() {
    return routesRoot() + "cart?country=US";
  }

  function cartApiUrl(path) {
    var url = routesRoot() + path;
    if (url.indexOf("country=") >= 0) return url;
    return url + (url.indexOf("?") >= 0 ? "&" : "?") + "country=US";
  }

  function maxQtyPerItem() {
    if (window.LbQtyLimit && typeof window.LbQtyLimit.max === "function") {
      return window.LbQtyLimit.max();
    }
    var n = Number(window.LB_MAX_QTY_PER_ITEM);
    return Number.isFinite(n) && n > 0 ? Math.floor(n) : 24;
  }

  function parseQuantity(value) {
    var n = Number(value);
    if (!Number.isFinite(n) || n < 1) return 1;
    n = Math.floor(n);
    var max = maxQtyPerItem();
    return n > max ? max : n;
  }

  function addedToastMessage(qty) {
    return qty === 1 ? "Added to cart" : "Added " + qty + " to cart";
  }

  function hideToast() {
    var toast = document.getElementById("lb-cart-toast");
    if (!toast) return;
    toast.classList.remove("is-visible", "is-interactive");
    clearTimeout(toast._timer);
  }

  function showToast(msg, isError) {
    var toast = document.getElementById("lb-cart-toast");
    if (!toast) {
      if (isError) window.alert(msg);
      return;
    }
    toast.textContent = msg;
    toast.className =
      "lb-cart-toast" + (isError ? " lb-cart-toast--error" : "") + " is-visible";
    clearTimeout(toast._timer);
    toast._timer = setTimeout(hideToast, isError ? 4000 : 2600);
  }

  function showAddedPanel(qty) {
    var toast = document.getElementById("lb-cart-toast");
    if (!toast) {
      showToast(addedToastMessage(qty), false);
      return;
    }
    toast.innerHTML =
      '<p class="lb-cart-toast__msg">' +
      addedToastMessage(qty) +
      "</p>" +
      '<div class="lb-cart-toast__actions">' +
      '<button type="button" class="lb-cart-toast__btn" data-toast-dismiss>Continue shopping</button>' +
      '<a href="' +
      cartPageUrl() +
      '" class="lb-cart-toast__btn lb-cart-toast__btn--gold">View cart</a>' +
      "</div>";
    toast.className = "lb-cart-toast is-visible is-interactive";
    clearTimeout(toast._timer);
    toast._timer = setTimeout(hideToast, 8000);
    var dismiss = toast.querySelector("[data-toast-dismiss]");
    if (dismiss) {
      dismiss.addEventListener("click", hideToast, { once: true });
    }
  }

  async function fetchCart() {
    var res = await fetch(cartApiUrl("cart.js"), {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });
    if (!res.ok) return null;
    return res.json();
  }

  async function refreshCartUi(cart) {
    if (!cart) return;
    if (
      window.LbUkUsShipping &&
      typeof window.LbUkUsShipping.updateHeaderCartCount === "function"
    ) {
      window.LbUkUsShipping.updateHeaderCartCount(cart);
    } else {
      var countEl = document.getElementById("lb-header-cart-count");
      if (countEl) {
        var units = 0;
        (cart.items || []).forEach(function (item) {
          if (!item) return;
          if (window.LbRemoveFee && window.LbRemoveFee.isFeeItem && window.LbRemoveFee.isFeeItem(item)) {
            return;
          }
          if (String(item.handle || item.product_handle || "") === "lb-order-margin") return;
          units += item.quantity || 0;
        });
        countEl.textContent = String(units);
      }
    }
    document.dispatchEvent(new CustomEvent("lb:cart-updated", { detail: { cart: cart } }));
    if (window.LbUkUsShipping && typeof window.LbUkUsShipping.refreshCart === "function") {
      window.LbUkUsShipping.refreshCart(cart);
    }
  }

  async function removeUnavailableItems(cart) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return cart;
    var unavailable = cart.items.filter(function (item) {
      return item && item.available === false;
    });
    if (!unavailable.length) return cart;

    var latest = cart;
    for (var i = 0; i < unavailable.length; i += 1) {
      var item = unavailable[i];
      var rm = await fetch(cartApiUrl("cart/change.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ id: item.key, quantity: 0 }),
      });
      if (!rm.ok) continue;
      latest = await rm.json();
    }
    return latest;
  }

  async function postAdd(payload) {
    return fetch(cartApiUrl("cart/add.js"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify(payload),
    });
  }

  async function postChange(lineKey, quantity) {
    return fetch(cartApiUrl("cart/change.js"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
    });
  }

  async function clampOverLimitLines(cart) {
    if (!cart || !window.LbQtyLimit || typeof window.LbQtyLimit.linesOverLimit !== "function") {
      return cart;
    }
    var over = window.LbQtyLimit.linesOverLimit(cart);
    if (!over.length) return cart;
    var latest = cart;
    for (var i = 0; i < over.length; i += 1) {
      var changeRes = await postChange(over[i].key, over[i].quantity);
      if (!changeRes.ok) continue;
      latest = await changeRes.json();
    }
    return latest;
  }

  function isFeeCartItem(item) {
    if (!item) return true;
    if (window.LbRemoveFee && typeof window.LbRemoveFee.isFeeItem === "function") {
      return window.LbRemoveFee.isFeeItem(item);
    }
    return String(item.handle || item.product_handle || "").trim() === "lb-order-margin";
  }

  function findCartLineForVariant(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var vid = String(variantId);
    for (var i = 0; i < cart.items.length; i += 1) {
      var item = cart.items[i];
      if (!item || isFeeCartItem(item)) continue;
      if (String(item.variant_id) === vid) return item;
    }
    return null;
  }

  async function upsertCardLine(variantId, qty) {
    var cart = await fetchCart();
    if (window.LbQtyLimit && typeof window.LbQtyLimit.capLineQty === "function") {
      qty = window.LbQtyLimit.capLineQty(qty, 1);
    }
    var line = cart ? findCartLineForVariant(cart, variantId) : null;
    if (line) {
      if (line.quantity === qty) return cart;
      var changeRes = await postChange(line.key, qty);
      if (!changeRes.ok) {
        var changeMsg = "Could not update cart.";
        try {
          var changeErr = await changeRes.json();
          if (changeErr && (changeErr.description || changeErr.message)) {
            changeMsg = changeErr.description || changeErr.message;
          }
        } catch (_e) {
          /* keep default */
        }
        throw new Error(changeMsg);
      }
      return changeRes.json();
    }

    var addRes = await postAdd({ id: variantId, quantity: qty });
    if (!addRes.ok) {
      var addMsg = "Could not add this item to cart.";
      try {
        var addErr = await addRes.json();
        if (addErr && (addErr.description || addErr.message)) {
          addMsg = addErr.description || addErr.message;
        }
      } catch (_e2) {
        /* keep default */
      }
      throw new Error(addMsg);
    }
    return fetchCart();
  }

  function pickBuyVariant(variants) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available !== false) return variants[i];
    }
    for (var j = 0; j < variants.length; j++) {
      if (variants[j].inventory_policy === "continue") return variants[j];
    }
    return variants.length ? variants[0] : null;
  }

  async function fetchFreshVariantId(form) {
    var m = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    if (!m) return null;
    var handle = m[1];
    var productRes = await fetch(cartApiUrl("products/" + handle + ".js"), {
      headers: { Accept: "application/json" },
    });
    if (!productRes.ok) return null;
    var product = await productRes.json();
    if (!product || !Array.isArray(product.variants) || !product.variants.length) {
      return null;
    }
    if (product.variants.length === 1) {
      var single = pickBuyVariant(product.variants);
      return single ? String(single.id) : String(product.variants[0].id);
    }
    var selectedTitle = "";
    var select = form.querySelector("select[name='id']");
    if (select && select.options && select.selectedIndex >= 0) {
      selectedTitle = (select.options[select.selectedIndex].text || "").split(" — ")[0].trim();
    }
    var found = product.variants.find(function (v) {
      return v && v.title && v.title.trim() === selectedTitle;
    });
    if (found && (found.available !== false || found.inventory_policy === "continue")) {
      return String(found.id);
    }
    var picked = pickBuyVariant(product.variants);
    return picked ? String(picked.id) : String(product.variants[0].id);
  }

  async function submitAddToCart(form, goToCheckout) {
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var submitBtn = form.querySelector('[type="submit"]');
    var checkoutBtn = form.querySelector('[data-checkout-now="true"]');

    if (!idInput || !idInput.value) {
      throw new Error("Missing variant id.");
    }

    if (submitBtn) submitBtn.disabled = true;
    if (checkoutBtn) checkoutBtn.disabled = true;
    var submitOriginal = submitBtn ? submitBtn.textContent : "";

    try {
      var requestedQty = parseQuantity(qtyInput ? qtyInput.value : "1");
      var qty = requestedQty;
      var existingCart = await fetchCart();
      if (window.LbQtyLimit && typeof window.LbQtyLimit.capAddQty === "function") {
        qty = window.LbQtyLimit.capAddQty(requestedQty, existingCart, idInput.value);
        if (qty < 1) {
          throw new Error(window.LbQtyLimit.message());
        }
      }
      var payload = {
        id: idInput.value,
        quantity: qty,
      };

      var res = await postAdd(payload);

      if (!res.ok) {
        var msg = "Could not add this item to cart.";
        var description = "";
        try {
          var err = await res.json();
          if (err && (err.description || err.message)) {
            description = err.description || err.message;
            msg = description;
          }
        } catch (_e) {
          /* keep default */
        }
        if (/sold out/i.test(description || "")) {
          var freshVariantId = await fetchFreshVariantId(form);
          if (freshVariantId && freshVariantId !== String(payload.id)) {
            payload.id = freshVariantId;
            idInput.value = freshVariantId;
            var retry = await postAdd(payload);
            if (retry.ok) {
              res = retry;
            } else {
              throw new Error(msg);
            }
          } else {
            throw new Error(msg);
          }
        } else {
          throw new Error(msg);
        }
      }

      var cart = await fetchCart();
      if (cart) {
        await refreshCartUi(cart);
      }

      if (goToCheckout) {
        cart = cart ? await removeUnavailableItems(cart) : cart;
        if (cart && cart.item_count === 0) {
          window.location.assign(cartPageUrl());
          return;
        }
        cart = await clampOverLimitLines(cart);
        if (window.LbRemoveFee && typeof window.LbRemoveFee.removeFeeLines === "function") {
          cart = await window.LbRemoveFee.removeFeeLines(cart);
        }
        window.location.assign(routesRoot() + "checkout");
        return;
      }

      if (submitBtn) submitBtn.textContent = "Added";
      if (qty < requestedQty && window.LbQtyLimit) {
        showToast(window.LbQtyLimit.limitedAddMessage(qty), true);
      } else {
        showAddedPanel(qty);
      }
      setTimeout(function () {
        if (submitBtn) submitBtn.textContent = submitOriginal;
      }, 1200);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
      if (checkoutBtn) checkoutBtn.disabled = false;
    }
  }

  function handleProductFormAdd(event) {
    var addBtn =
      event.target && event.target.closest
        ? event.target.closest("#add-to-cart-btn, [data-add-to-cart]")
        : null;
    if (!addBtn) return;
    var form = addBtn.closest("form#product-form");
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    submitAddToCart(form, false).catch(function (err) {
      showToast(err instanceof Error ? err.message : "Could not add to cart.", true);
    });
  }

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.id !== "product-form") return;

    event.preventDefault();
    event.stopPropagation();
    submitAddToCart(form, false).catch(function (err) {
      showToast(err instanceof Error ? err.message : "Could not add to cart.", true);
    });
  }, true);

  document.addEventListener("click", handleProductFormAdd, true);

  document.addEventListener("click", function (event) {
    var btn =
      event.target && event.target.closest
        ? event.target.closest('[data-checkout-now="true"]')
        : null;
    if (!btn) return;
    var form = btn.closest("form.lb-cart-form");
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    submitAddToCart(form, true).catch(function (err) {
      showToast(err instanceof Error ? err.message : "Could not start checkout.", true);
    });
  }, true);

  function headerCartUnits(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    var units = 0;
    cart.items.forEach(function (item) {
      if (!item) return;
      if (window.LbRemoveFee && typeof window.LbRemoveFee.isFeeItem === "function") {
        if (window.LbRemoveFee.isFeeItem(item)) return;
      } else if (String(item.handle || item.product_handle || "").trim() === "lb-order-margin") {
        return;
      }
      units += item.quantity || 0;
    });
    return units;
  }

  function readHeaderCartUnits() {
    var countEl = document.getElementById("lb-header-cart-count");
    if (!countEl) return 0;
    return parseInt(countEl.textContent, 10) || 0;
  }

  function setHeaderCartUnits(units) {
    var countEl = document.getElementById("lb-header-cart-count");
    if (!countEl) return;
    countEl.textContent = String(units);
    var cartLink = countEl.closest(".lb-header-cart");
    if (cartLink) cartLink.setAttribute("aria-label", "Cart, " + units + " items");
  }

  async function cardAdd(variantId, qty, btn, goCheckout) {
    if (!variantId || !btn || btn.disabled) return;
    goCheckout = !!(goCheckout && btn.hasAttribute("data-card-buy"));

    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = "Adding…";

    try {
      var cart = await upsertCardLine(variantId, qty);
      if (cart) {
        await refreshCartUi(cart);
      }

      if (goCheckout) {
        cart = cart ? await removeUnavailableItems(cart) : cart;
        cart = await clampOverLimitLines(cart);
        if (window.LbRemoveFee && typeof window.LbRemoveFee.removeFeeLines === "function") {
          cart = await window.LbRemoveFee.removeFeeLines(cart);
        }
        if (!cart || cart.item_count === 0) {
          showToast("Could not start checkout.", true);
          return;
        }
        window.location.assign(routesRoot() + "checkout");
        return;
      }

      btn.textContent = "Added";
      showAddedPanel(qty);
      setTimeout(function () {
        btn.textContent = original;
      }, 1200);
    } catch (e) {
      btn.textContent = original;
      showToast(e instanceof Error ? e.message : "Could not add item", true);
    } finally {
      if (!goCheckout) btn.disabled = false;
    }
  }

  window.__lbCardAddBound = true;
  document.addEventListener(
    "click",
    function (event) {
      var addBtn =
        event.target && event.target.closest
          ? event.target.closest("[data-card-add]")
          : null;
      var buyBtn =
        event.target && event.target.closest
          ? event.target.closest("[data-card-buy]")
          : null;
      var btn = addBtn || buyBtn;
      if (!btn) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var card = btn.closest("[data-product-card]");
      var qtyInput = card ? card.querySelector("[data-card-qty]") : null;
      var variantId = btn.getAttribute("data-variant-id");
      var qty = qtyInput
        ? parseQuantity(qtyInput.value)
        : parseQuantity(btn.getAttribute("data-qty") || "1");
      cardAdd(variantId, qty, btn, !addBtn && !!buyBtn);
    },
    true
  );
})();
